import { api } from '@/shared/api/http'
import type { LanguagePreference } from './types'

/**
 * 화면 언어를 고른 것을 계정에 남긴다.
 *
 * 테마와 나눠 각각 PUT으로 둔다. 두 값을 한 번에 교체하면 한쪽만 바꾼 요청이 다른 쪽을
 * 되돌린다. 읽는 자리는 따로 두지 않고 내 정보 조회 응답이 함께 나른다.
 */
export function updateLanguagePreference(
  preference: LanguagePreference,
): Promise<LanguagePreference> {
  return api.put<LanguagePreference>('/me/language-pref', preference)
}
